"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var canvas_utils_1 = require("./canvas.utils");
var svg_engine_1 = require("./svg.engine");
var RTR_TEMPLATE = /(%.*?)%/;
var getVerticalAlignment = function (_a) {
    var vertical_alignment = _a.vertical_alignment;
    switch (vertical_alignment) {
        case "bottom":
            return "align-items: flex-end;";
        case "top":
            return "align-items: flex-start;";
        default:
            return "align-items: center;";
    }
};
function textProcessor(svg, layer, data, debug) {
    return __awaiter(this, void 0, void 0, function () {
        var text, x, y, width, height, _a, rotation, style, foreignObjectNode, mainStyle;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (debug)
                        console.log("[RTR] [text]: Processing layer: ", layer);
                    text = layer.text || data[layer.tag];
                    if (RTR_TEMPLATE.exec(text)) {
                        text = text.replace(/%(\w*)%/g, function (_, key) { var _a; return (_a = data[key]) !== null && _a !== void 0 ? _a : "#".concat(key, "#"); });
                    }
                    x = layer.positionX, y = layer.positionY, width = layer.width, height = layer.height, _a = layer.rotation, rotation = _a === void 0 ? 0 : _a;
                    return [4 /*yield*/, (0, canvas_utils_1.getRTRFontStyle)(layer)];
                case 1:
                    style = _b.sent();
                    if (debug)
                        console.log("[RTR] [text]: RTR font style: " + style);
                    foreignObjectNode = svg_engine_1.SVGEngine.getNode("foreignObject", {
                        width: width,
                        height: height,
                        x: x,
                        y: y,
                        style: "transform-origin: 0 0;transform-box: fill-box;transform: rotate(".concat(-rotation, "deg)"),
                    });
                    mainStyle = "display: flex;justify-content: center;";
                    mainStyle += "width: ".concat(width, "px;height: ").concat(height, "px;");
                    mainStyle += getVerticalAlignment(layer);
                    foreignObjectNode.innerHTML = "\n  <div style='".concat(mainStyle, "'>\n    <div xmlns='http://www.w3.org/1999/xhtml' style='").concat(style, ";display: block; flex: 1;'>\n      ").concat(text, "\n    </div>\n  </div>");
                    if (debug)
                        console.log("[RTR] [text]: SVG text layer: " + foreignObjectNode.innerHTML);
                    svg.appendChild(foreignObjectNode);
                    if (debug)
                        console.log("[RTR] [text]: Done");
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = textProcessor;
